export default __webpack_public_path__ + "static/media/NoButton.a7ebb3ef.png";